import {Component, OnDestroy, OnInit} from "@angular/core";
import {FormBuilder, Validators, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from "@angular/material/card";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {FuseAlertComponent} from "../../../../@fuse/components/alert";
import {MatInput} from "@angular/material/input";
import {EntrySelectorComponent} from "../../../layout/common/selectors/entry-selector.component";
import {AdmissionMotif} from "../../../model/admission/admission-motif.model";
import {AdmissionMotifsService} from "../../../services/admission-motifs.service";
import {MatButton} from "@angular/material/button";
import {QueueService} from "../../../services/queue.service";
import {JoinQueueRequest} from "../../../model/queue/join-queue-request.model";
import {TicketDTO} from "../../../model/queue/ticketDTO.model";
import {MatIcon} from "@angular/material/icon";
import {Subject, takeUntil} from "rxjs";
import {EstablishmentBranding, EstablishmentParamService} from "../../../services/establishment-param.service";

@Component({
    selector: 'join-queue',
    templateUrl: 'join-queue.component.html',
    imports: [
        MatCardContent,
        MatCardHeader,
        MatCardTitle,
        MatCard,
        MatFormField,
        ReactiveFormsModule,
        FuseAlertComponent,
        MatInput,
        MatLabel,
        EntrySelectorComponent,
        MatButton,
        MatIcon,
    ]
})

export class JoinQueueComponent implements OnInit, OnDestroy {
    queueForm: FormGroup;
    currentTicket: TicketDTO = null;

    motifs: AdmissionMotif[];

    branding: EstablishmentBranding;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(private fb: FormBuilder,
                private admissionMotifService: AdmissionMotifsService,
                private queueService: QueueService,
                private establishmentParamService: EstablishmentParamService) {

        this.branding = this.establishmentParamService.branding;

        this.queueForm = this.fb.group({
            'firstName': ['', [Validators.required]],
            'lastName': ['', [Validators.required]],
            'motif': ['', [Validators.required]]
        });

        if (!this.motifs) {
            this.admissionMotifService.getAll(0, 10, '', 'name', 'asc', true).subscribe((data: any) => {
                if (Array.isArray(data)) {
                    this.motifs = data;
                } else if (data && data.content) {
                    this.motifs = data.content;
                } else {
                    this.motifs = [];
                }
            });
        }

        this.alreadyHaveTicket();
    }

    ngOnInit(): void {
        this.establishmentParamService.branding$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((branding: EstablishmentBranding) => {
                this.branding = branding;
            });
        this.establishmentParamService.load().subscribe();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    joinQueue() {
        if (this.queueForm.valid) {
            let newQueueRequest: JoinQueueRequest = {
                firstName: this.queueForm.value.firstName,
                lastName: this.queueForm.value.lastName,
                deviceId: this.getDeviceUUID(),
                admissionMotifId: JSON.parse(this.queueForm.value.motif).id
            }

            this.queueService.join(newQueueRequest).subscribe({
                next: (data) => {
                    this.currentTicket = data;
                    console.log("ok");
                },
                error: err => {
                    console.log("error");
                }
            });
        }
    }

    getDeviceUUID(): string {
        let uuid = localStorage.getItem('device_uuid');

        if (!uuid) {
            uuid = self.crypto.randomUUID();
            localStorage.setItem('device_uuid', uuid);
        }

        return uuid;
    }

    alreadyHaveTicket() {
        if (!this.currentTicket) {
            this.queueService.getTicketByUUID(this.getDeviceUUID()).subscribe({
                next: (data: any) => {
                    this.currentTicket = data;
                },
                error: err => {
                    this.currentTicket = null;
                }
            })
        }
    }
}